import { useTranslation } from "react-i18next";
import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { Money } from "./Money";
import { Card3D } from "./Card3D";

// آخر الحركات النقدية — كل صف كارت داخلي بتباين اتجاه.
export const RecentMovesCard = ({ moves }) => {
  const { t } = useTranslation();
  return (
    <Card3D titleKey="acct.recentMoves" testid="recent-moves">
      {(!moves || moves.length === 0) ? (
        <p className="py-6 text-center text-xs text-muted-foreground">—</p>
      ) : (
        <div className="grid gap-1.5">
          {moves.slice(0, 10).map((mv) => {
            const isIn = mv.direction === "in";
            const Icon = isIn ? ArrowUpRight : ArrowDownRight;
            const color = isIn ? "text-emerald-500" : "text-rose-500";
            return (
              <div key={mv.id} data-testid={`recent-${mv.id}`}
                   className="flex items-center gap-3 rounded-xl bg-background/40 px-3 py-2 text-[11px] shadow-neu-in">
                <span className={`grid h-7 w-7 place-content-center rounded-full bg-current/10 ${color}`}
                      style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
                  <Icon className="h-4 w-4" />
                </span>
                <span className="font-mono" dir="ltr">{mv.date}</span>
                <span className="min-w-0 flex-1 truncate text-muted-foreground">
                  {t(`acct.moveKind.${mv.kind}`, mv.kind || "")}
                </span>
                <Money value={mv.amount} currency={mv.currency}
                       className={`text-xs font-black ${color}`} />
                <span className="font-mono text-[10px] text-primary" dir="ltr">{mv.entry_number}</span>
              </div>
            );
          })}
        </div>
      )}
    </Card3D>
  );
};
